var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"stroke":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{staticClass:"spinner_V8m1"},[_c('circle',{attrs:{"cx":"12","cy":"12","fill":"none","r":"9.5","stroke-width":"3"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }